
define('app/board/views/headerTeamBidView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueInstanceModel',
	'known/models/userModel',
], function($, _, Backbone, LeagueInstanceModel, UserModel){
	var HeaderTeamBidView = Backbone.View.extend({
		initialize: function(options) {
			this.user = options.user;
			this.leagueInst = options.leagueInst;
			this.draftStatusModel = options.draftStatusModel;
			this.submittedData = {isSubmitted : false};
			
			this.currentRoundPosId = 0;
			this.currentWinningBid = 0;
			this.currentTeamBids = {};
			this.bidRanking = 99;
			
			_.bindAll(this, 'submitBid');
			_.bindAll(this, 'updateTeamInfo');
			_.bindAll(this, 'error');
			_.bindAll(this, 'success');
			
			this.listenTo(this.user, 'change', this.updateUserVisuals);			
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				
				if($(this.el).has('#teamBidRosterSize').length){
					//Standard View
					this.teamSelect = $(this.el).find('.teamBidSelect');
					this.bidBtnEl = this.$el.find('.teamBidSubmit');
					this.bidInputEl = this.$el.find('.teamBidInput');
					this.bidCurAmountEl = this.$el.find('.teamBidAmountLabel');
					this.teamBidMaxEl = this.$el.find('.teamBidMaxBid');
					this.teamBidRosterSizeEl = this.$el.find('#teamBidRosterSize');
					this.teamFundsLeftEl = this.$el.find('#teamBidFundsLeft');
				} else {
					//Mobile View
					this.teamSelect = $("#draftBoardHdrMobileInfoContainer").find('.teamBidSelect');
					this.bidBtnEl = $("#draftBoardHdrMobileInfoContainer").find('.teamBidSubmit');
					this.bidInputEl = $("#draftBoardHdrMobileInfoContainer").find('.teamBidInput');
					this.bidCurAmountEl = $("#draftBoardHdrMobileInfoContainer").find('.teamBidAmountLabel');
					this.teamBidMaxEl = $("#draftBoardHdrMobileInfoContainer").find('.teamBidMaxBid');
				}
				
				this.populateDropdown();
				
				this.listenTo(this.draftStatusModel, 'change', this.updateAuctionInfo);
				
				this.teamSelect.on('change', this.updateTeamInfo);
				this.bidBtnEl.on('click', {}, this.submitBid);
			}
		},
	
		render: function () {		
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				this.updateUserVisuals();
				this.updateAuctionInfo();
			}
			
			return this;
		},
		
		populateDropdown: function() {
			var teams = this.leagueInst.getTeamList();
			var foundOwnedTeam = false;
			
			this.teamSelect.empty();
			
			_.each(teams, function(team){
				var optionStart = "<option value=\"";
				var optionMiddle = "\" >";
				var optionEnd = "</option>";
				var selected = "";
				
				if(!foundOwnedTeam && team.get("leagueUserId") == this.user.get("id")){
					selected = "\" selected=\"true";
					foundOwnedTeam = true;
				}
				
				this.teamSelect.append(optionStart 
						+ team.get("id")
						+ selected
						+ optionMiddle
						+ team.get("teamName")		
						+ optionEnd);				
			}, this);
			
			if(!foundOwnedTeam){
				this.teamSelect.val(this.leagueInst.getTeamByDraftPosition(1).get('id'));
			}
		},
		
		submitBid: function(event) {
			event.preventDefault();
			
			if(!this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = true;
				
				var valueInput = this.bidInputEl.val();
				var numPattern = new RegExp("^[0-9]*$");
				var error = false;
				
				if(!valueInput){
					error = true;
				} else if(valueInput && valueInput.length == 0){
					error = true; 
				} else if(!valueInput.match(numPattern)){
					error = true; 
				}
				
				if(error){
					this.error();
					return this;
				}
				
				var team = this.leagueInst.getTeam(this.teamSelect.val());
				valueInput = parseInt(valueInput);
				var curBudget = this.draftStatusModel.get('teamBudget')[team.get('id')];
				var playersPicked = this.draftStatusModel.get('teamPickCount')[team.get('id')];
				var maxPlayers = this.draftStatusModel.get('teamMaxNumPicks')[team.get('id')];
				var maxBid = curBudget-(maxPlayers-playersPicked)+1;
				
				if(valueInput <= this.draftStatusModel.get('auctionBidValue') || valueInput > maxBid || valueInput < 1 || valueInput > 999) {
					error = true;
				}
				
				if(error){
					this.error();
					return this;
				} else {
					var round = this.draftStatusModel.get('round');
					var posInRound = this.draftStatusModel.get('posInRound');
					var keeper = false;
					var autoDrafted = false;
					
					var msg = {
							"leagueInstanceId":this.leagueInst.get('id'), 
							"fantasyTeamId":team.get('id'), 
							"draftablePlayerId":this.draftStatusModel.get('auctionBidPlayerId'), 
							"value":valueInput, 
							"round":round,
							"posInRound":posInRound, 
							"keeper":keeper};
					
					$.ajax({
						headers : {
							"Content-Type" : "application/json",
							"Accept" : "application/json"
						},
						url : '/draftapp/leagues/' 
							+ this.leagueInst.get('leagueId') 
							+ '/league-instances/' 
							+ this.leagueInst.get('id')
							+ '/picks/'
							+ this.draftStatusModel.get('auctionPickId'),
						type : 'PUT',
						dataType : 'json',
						//accepts: 'application/json',
						//contentType: 'application/json',
						data : JSON.stringify(msg, null, 2),
						success: this.success,
						error: this.error
					});
				}
			}
		},
		
		error: function() {
			this.bidInputEl.addClass('error');
			this.submittedData.isSubmitted = false;
		},
		
		success: function() {
			this.bidInputEl.removeClass('error');
			this.submittedData.isSubmitted = false;
		},
		
		updateAuctionInfo: function() {
			var team = this.leagueInst.getTeam(this.teamSelect.val());
			var userName = this.user.get('userName');
			var isAssistant = this.leagueInst.isAssistant(userName);
			var teamOwner = this.leagueInst.getTeamOwner(team.get('id'));
			
			//new bid so reset the cached numbers
			if(this.currentRoundPosId != ((this.draftStatusModel.get('round') * 1000) + this.draftStatusModel.get('posInRound')) || !this.draftStatusModel.get('auctionBidding')){
				this.currentRoundPosId = (this.draftStatusModel.get('round') * 1000) + this.draftStatusModel.get('posInRound');
				this.currentWinningBid = 0;
				this.currentTeamBids = {};
				
				if(!$(this.bidInputEl).is(':focus')){
					this.bidInputEl.val(1);
				}
				
				if(userName.toUpperCase() == teamOwner.toUpperCase()){
					this.teamSelect.val(team.get('id'));
				}
			}
			
			if(this.draftStatusModel.get('auctionBidding') && this.currentWinningBid != this.draftStatusModel.get('auctionBidValue')){
				this.currentWinningBid = this.draftStatusModel.get('auctionBidValue');				
				this.currentTeamBids[this.draftStatusModel.get('auctionWinningTeamId')] = this.draftStatusModel.get('auctionBidValue');
			}
			
			var curBudget = this.draftStatusModel.get('teamBudget')[team.get('id')];
			var playersPicked = this.draftStatusModel.get('teamPickCount')[team.get('id')];
			var maxPlayers = this.draftStatusModel.get('teamMaxNumPicks')[team.get('id')];
			var maxBid = curBudget-(maxPlayers-playersPicked) + 1;
			
			this.bidCurAmountEl.html('$' + (this.currentTeamBids[team.get('id')] ? this.currentTeamBids[team.get('id')] : 0));
			this.teamBidMaxEl.html((maxPlayers-playersPicked) <= 0 ? 0 : maxBid);
			
			if($(this.el).has('#teamBidRosterSize').length){
				//Standard View
				this.teamBidRosterSizeEl.html(playersPicked	+ '/' + maxPlayers);
				this.teamFundsLeftEl.html(curBudget);
			}
			
			if(this.currentTeamBids[team.get('id')] == this.currentWinningBid){
				this.$el.removeClass('losingBidTeam');
				this.$el.removeClass('eliminatedBidTeam');
				this.$el.addClass('winningBidTeam');
			} else if(playersPicked >= maxPlayers) {
				this.$el.removeClass('winningBidTeam');
				this.$el.removeClass('losingBidTeam');
				this.$el.addClass('eliminatedBidTeam');
			} else if(this.draftStatusModel.get('auctionBidValue') >= maxBid) {
				this.$el.removeClass('winningBidTeam');
				this.$el.removeClass('losingBidTeam');
				this.$el.addClass('eliminatedBidTeam');
			} else if(this.currentTeamBids[team.get('id')] && this.currentTeamBids[team.get('id')] > 0) {
				this.$el.removeClass('winningBidTeam');
				this.$el.removeClass('eliminatedBidTeam');
				this.$el.addClass('losingBidTeam');
			} else {
				this.$el.removeClass('winningBidTeam');
				this.$el.removeClass('losingBidTeam');
				this.$el.removeClass('eliminatedBidTeam');
			}
			
			//increment the bid if it is less than or equal to current winning bid
			if(!$(this.bidInputEl).is(':focus') && (!$.isNumeric(this.bidInputEl.val()) || parseInt(this.bidInputEl.val()) <= this.draftStatusModel.get('auctionBidValue'))) {
				this.bidInputEl.val(this.draftStatusModel.get('auctionBidValue') + 1);
				this.bidInputEl.removeClass('error');
			}
			
			
			
			if(this.currentTeamBids[team.get('id')] == this.currentWinningBid || this.currentWinningBid > maxBid || playersPicked >= maxPlayers){
				this.bidBtnEl.css({'visibility': 'hidden'});
				this.bidInputEl.css({'visibility': 'hidden'});
			} else if(this.draftStatusModel.get('auctionBidding') && (isAssistant || userName.toUpperCase() == teamOwner.toUpperCase())){
				this.bidBtnEl.css({'visibility': ''});
				this.bidInputEl.css({'visibility': ''});
			} else {
				this.bidBtnEl.css({'visibility': 'hidden'});
				this.bidInputEl.css({'visibility': 'hidden'});
			}
		},
		
		updateTeamInfo: function() {
			this.updateUserVisuals();
			this.updateAuctionInfo();
		},
		
		updateUserVisuals: function () {
			var team = this.leagueInst.getTeam(this.teamSelect.val());
			var teamOwner = this.leagueInst.getTeamOwner(team.get('id'));
			var userName = this.user.get('userName');
			var isAssistant = this.leagueInst.isAssistant(userName);
			
			if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
				this.bidBtnEl.removeClass('btn-success');
				this.bidBtnEl.addClass('btn-info');
				this.bidBtnEl.css({'visibility': ''});
				this.bidInputEl.css({'visibility': ''});
			} else if(userName.toUpperCase() == teamOwner.toUpperCase()){
				this.bidBtnEl.removeClass('btn-info');
				this.bidBtnEl.addClass('btn-success');
				this.bidBtnEl.css({'visibility': ''});
				this.bidInputEl.css({'visibility': ''});
			} else {
				this.bidBtnEl.removeClass('btn-info');
				this.bidBtnEl.addClass('btn-success');
				this.bidBtnEl.css({'visibility': 'hidden'});
				this.bidInputEl.css({'visibility': 'hidden'});
			}
		}
	});

	return HeaderTeamBidView;  
});